import {useEffect} from "react";
import {Column} from "components";
import {Header, Table} from "./lib";
import {get} from "global/slices/clients/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import {initialState} from "global/slices/clients/initial-state";

interface ClientsProps {}

export const Clients: React.FC<ClientsProps> = () => {
  const dispatch = useAppDispatch();
  const {clients} = useAppSelector("clients");
  useEffect(() => {
    if (!clients["length"]) dispatch(get(initialState["pagination"]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients]);

  return (
    <Column>
      <Header />
      <Table />
    </Column>
  );
};
